// removed by extract-text-webpack-plugin
module.exports = {"author":"_3H9G","more":"_3Fgi"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Blog/BlogAuthor/BlogAuthor.scss
// module id = QWzy
// module chunks = 0